import m from "mithril";
import { dialog } from "../dialog/dialog";
import { getTextFixed } from "../../state/translations";
import "./shareDialog.scss";
import state from "../../state/state";
import { getFullProduct, getProductDetails, getProductName } from "../../state/api";
import { find } from "../../state/data";
import { isLoggedIn } from "../../utils/login";
// import { getAsset } from "../../utils/utils"
const download = async (progress) => {
    progress(0);
    const articles = [];
    let i = 0;
    const total = Math.max(Object.keys(state.articles).length + Object.keys(state.crosssellArticles).length, 1);
    for (const artCodeTSNL in state.articles) {
        let name = "";
        let price = 0;
        const p = find(artCodeTSNL, state.products.filtered)?.product;
        const details = await (p ? getFullProduct(p) : getProductDetails(artCodeTSNL)).catch(() => ({}));
        name = getProductName(p ?? {}, details);
        price = isLoggedIn ? details?.price ?? 0 : 0;
        articles.push({
            artCodeTSNL,
            quantity: state.getQuantity(artCodeTSNL),
            name,
            price,
        });
        const crosssell = (state.crosssellArticles[artCodeTSNL] ?? {});
        const parent = artCodeTSNL;
        for (const artCodeTSNL in crosssell) {
            let name = "";
            let price = 0;
            const p = find(artCodeTSNL, state.products.filtered)?.product;
            const details = await (p ? getFullProduct(p) : getProductDetails(artCodeTSNL)).catch(() => ({}));
            name = getProductName(p ?? {}, details);
            price = isLoggedIn ? details?.price ?? 0 : 0;
            articles.push({
                artCodeTSNL,
                quantity: state.getCrosssellQuantity(parent, artCodeTSNL),
                name: `\u21b3 ${name}`,
                price,
                isRelated: true,
            });
            progress((i++ / total) * .5);
        }
    }
    const mod = await import("../pdf/pdf");
    progress(0.6);
    const result = await mod.downloadPDF({
        url: state.getURL(),
        wissel: {
            type: state.wissel.type.value,
            wisselLigger: state.wissel.wisselLigger.value,
            hoekVerhouding: state.wissel.hoekVerhouding.value,
            spoorStaafProfiel: state.wissel.spoorStaafProfiel.value,
            boogStraal: state.wissel.boogStraal.value,
        },
        prorail: state.getProrailChoice(),
        articles
    }, n => progress(0.6 + n * 0.4));
    progress(1);
    return result;
};
export const shareDialog = () => {
    let pct = 0;
    const d = dialog({
        // title: getTextFixed("PLACING_ORDER"),
        close: false,
        dismiss: false,
        backdrop: true,
        className: "share-dialog"
    }, _close => [
        // <img src={getAsset("images/loading.gif")} />,
        m("p", null, getTextFixed("PLEASE_WAIT_WHILE_WE_DOWNLOAD_YOUR_PDF")),
        m("div", { class: "order-progress-bar" },
            m("div", { class: "order-progress-bar__track" },
                m("div", { class: "order-progress-bar__fill", style: { width: pct + "%" } })),
            m("span", { class: "order-progress-bar__label" },
                pct,
                "%"))
    ]);
    download(n => {
        pct = Math.round(n * 100);
        m.redraw();
    })
        .then(() => {
        d.close();
    })
        .catch(err => {
        console.error(err);
        d.close();
    });
    return {
        promise: d.promise,
        close: d.close,
    };
};
